import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import Header from "./layout-header";
import { Styled } from "./styles";
import useLocale from "@/context/locale";

const Navigation: React.FC = () => {
    useLocale(state => state.locale);

    return (
        <Styled.Container>
            <Sidebar />
            <Styled.Main>
                <Header />
                <Outlet />
            </Styled.Main>
        </Styled.Container>
    );
};

export default Navigation;
